import { render } from "./StudyTypeFieldDialog.vue?vue&type=template&id=94bffe34"
import script from "./StudyTypeFieldDialog.vue?vue&type=script&lang=js"
export * from "./StudyTypeFieldDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__